import { createSlice } from '@reduxjs/toolkit'
import {
  downloadFailedFile,
  filterImportUsersRolesDetailsList,
  importUsersRolesDetailsListPagination,
  importUsersRolesDetailsResetAlertHandler,
  retrieveImportUsersRolesDetailsByID,
  retrieveImportUsersRolesDetailsListByID,
  searchImportUsersRolesDetailsList,
} from './importUsersRolesDetailsThunk'

const defaultPageSize = 50
const defaultActiveSummary = 'ALL'

const initialState = {
  loading: false,
  alert: {},
  pageNumber: 0,
  summaries: {},
  sortBy: [],
  activeSort: {},
  filterList: [],
  activeFilters: [],
  pageSize: defaultPageSize,
  activeSummary: defaultActiveSummary,
  activeSearch: '',
  data: [],
  lookups: {},
  updatedItem: {},
  sideBar: {},
  finalPage: true,
  importUsersRolesDetails: {},
  batchId: 0,
  RolesDetailsLoadingStatus: false,
}

const importUsersRolesDetailsSlice = createSlice({
  name: 'importUsersRolesDetails',
  initialState,
  extraReducers: {
    [importUsersRolesDetailsResetAlertHandler.fulfilled]: (state) => {
      state.alert = {}
    },
    [retrieveImportUsersRolesDetailsByID.pending]: (state) => {
      state.RolesDetailsLoadingStatus = true
      state.alert = {}
    },
    [retrieveImportUsersRolesDetailsByID.rejected]: (state, { payload }) => {
      state.RolesDetailsLoadingStatus = false
      state.alert = payload
    },
    [retrieveImportUsersRolesDetailsByID.fulfilled]: (state, { payload }) => {
      state.importUsersRolesDetails = payload.data
      state.RolesDetailsLoadingStatus = false
      state.alert = {}
    },
    [retrieveImportUsersRolesDetailsListByID.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [retrieveImportUsersRolesDetailsListByID.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [retrieveImportUsersRolesDetailsListByID.fulfilled]: (state, { payload }) => {
      state.data = payload.response.users_roles
      state.batchId = payload.batchId
      state.summaries.all = payload.response.metadata.all
      state.sortBy = payload.response.sort
      state.filterList = payload.response.facets.status
      state.finalPage = payload.response.users_roles?.length < state.pageSize
      state.activeSort = payload.response.sort[0] || {}
      state.activeFilters = []
      state.updatedItem = {}
      state.pageNumber = 0
      state.loading = false
      state.alert = {}
      state.activeSearch = ''
    },
    [filterImportUsersRolesDetailsList.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [filterImportUsersRolesDetailsList.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [filterImportUsersRolesDetailsList.fulfilled]: (state, { payload }) => {
      state.activeFilters = payload.filter
      state.data = payload.response.users_roles
      state.summaries.all = payload.response.metadata.all
      state.sortBy = payload.response.sort
      state.filterList = payload.response.facets.status
      state.finalPage = payload.response.users_roles?.length < state.pageSize
      state.pageNumber = 0
      state.loading = false
      state.alert = {}
    },
    [searchImportUsersRolesDetailsList.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [searchImportUsersRolesDetailsList.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [searchImportUsersRolesDetailsList.fulfilled]: (state, { payload }) => {
      state.activeSearch = payload.search
      state.data = payload.response?.users_roles
      state.summaries.all = payload.response.metadata.all
      state.finalPage = payload.response.users_roles?.length < state.pageSize
      state.pageNumber = 0
      state.loading = false
      state.alert = {}
      state.filterList = payload.response.facets.status
    },
    [importUsersRolesDetailsListPagination.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [importUsersRolesDetailsListPagination.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [importUsersRolesDetailsListPagination.fulfilled]: (state, { payload }) => {
      state.data = payload.response.users_roles
      state.summaries.all = payload.response.metadata.all
      state.sortBy = payload.response.sort
      state.filterList = payload.response.facets.status
      state.finalPage = payload.response.users_roles?.length < state.pageSize
      state.pageNumber = payload.pageNumber
      state.loading = false
      state.alert = {}
    },
    [downloadFailedFile.pending]: (state) => {
      state.alert = {}
      state.loading = true
    },
    [downloadFailedFile.rejected]: (state, { payload }) => {
      state.alert = payload
      state.loading = false
    },
    [downloadFailedFile.fulfilled]: (state) => {
      state.alert = {}
      state.loading = false
    },
  },
})

export const selectImportUsersRolesDetails =
({ importUsersRolesDetails }) => importUsersRolesDetails
export default importUsersRolesDetailsSlice.reducer
